export default "/images/global-min.webp?8bf23be1fcca473d12122d911fae3a6e";